export const MODULE_NAME = 'matomo'

export const CONVERSION_TYPES = {
  PHONE: 'PHONE',
  CONTACT: 'CONTACT',
  PREBOOKING: 'PREBOOKING',
  ONLINE_BOOKING: 'ONLINE_BOOKING',
} as const

export type ConversionType =
  (typeof CONVERSION_TYPES)[keyof typeof CONVERSION_TYPES]

export const SKUS: Record<ConversionType, number> = {
  PHONE: 1,
  CONTACT: 2,
  PREBOOKING: 3,
  ONLINE_BOOKING: 4,
}

export const PRODUCT_NAMES: Record<ConversionType, string> = {
  PHONE: 'PHONE',
  CONTACT: 'CONTACT',
  PREBOOKING: 'PREBOOKING',
  ONLINE_BOOKING: 'ONLINE_BOOKING',
}

export const FIXED_AMOUNTS = {
  PHONE: 1,
  CONTACT: 5,
} as const

export const MATOMO_CUSTOM_DIMENSION_COTTAGE_ID = '6'
